import { AuthService } from "../auth/auth.service";
import { history } from "react-router-guard";

export class GuardsService {
  private authService: AuthService = new AuthService();

  public isAuthorized = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const user = await this.authService.me();
        return resolve(user);
      } catch(error) {
        history.push({
          pathname: `/login`,
        });
        return reject();
      }
    });
  }

  public isNotAuthorized = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const user = await this.authService.me();
        history.push({
          pathname: `/buildings`,
        });
        return reject(user);
      } catch {
        return resolve();
      }
    });
  }
}
